<template>
  <fragment>
    <div class="help-support--banner">
      <div class="container">
        <div class="help-support--banner--heading">
          <h2> Hello, how can we help you? </h2>
        </div>
      </div>
    </div>

    <div class="help-support--content">
      <div class="container">
        <div class="row">
          <div class="help-support--content--section-heading">
            <h3> Featured FAQs </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 accordion">
            <div class="accordion-item" id="help-category-1" data-toggle-group="help-category-group-1">
              <div class="toggler help-support--content--col-heading" data-toggle-target="#help-category-1"
                data-toggle-group="help-category-group-1"
                data-toggle-on-active-match-height="#help-category-1 .accordion-item--content-wrapper"
                data-toggle-on-active-match-height-src="#help-category-1 .help-support--content--col-content"
                data-toggle-on-active-scroll-to-view-container="#help-category-1"
                data-toggle-on-active-scroll-to-view-view="#help-category-1"
                data-toggle-on-active-scroll-to-view-offset="15" data-toggle-on-active-scroll-to-view-delay="300"
                data-toggle-on-active-scroll-to-view-duration="250">
                <img src="@/assets/images/help-support/icon-banking.svg">
                <h4> {{$t('faq.banking')}} </h4>
              </div>
              <div class="accordion-item--content-wrapper">
                <div class="help-support--content--col-content">
                  <router-link to="/resources/faq?category=2&amp;question=1"> How do I fund my account? </router-link>
                  <router-link to="/resources/faq?category=2&amp;question=2"> Are my funds safe? </router-link>
                  <router-link to="/resources/faq?category=2&amp;question=6"> Can I cancel a withdrawal request? </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 accordion">
            <div class="accordion-item" id="help-category-2" data-toggle-group="help-category-group-2">
              <div class="toggler help-support--content--col-heading" data-toggle-target="#help-category-2"
                data-toggle-group="help-category-group-2"
                data-toggle-on-active-match-height="#help-category-2 .accordion-item--content-wrapper"
                data-toggle-on-active-match-height-src="#help-category-2 .help-support--content--col-content"
                data-toggle-on-active-scroll-to-view-container="#help-category-2"
                data-toggle-on-active-scroll-to-view-view="#help-category-2"
                data-toggle-on-active-scroll-to-view-offset="15" data-toggle-on-active-scroll-to-view-delay="300"
                data-toggle-on-active-scroll-to-view-duration="250">
                <img src="@/assets/images/help-support/icon-account.svg">
                <h4> {{$t('faq.account')}} </h4>
              </div>
              <div class="accordion-item--content-wrapper">
                <div class="help-support--content--col-content">
                  <router-link to="/resources/faq?category=2&amp;question=3"> How do I open an account? </router-link>
                  <router-link to="/resources/faq?category=2&amp;question=8"> Are you regulated? </router-link>
                  <router-link to="/resources/faq?category=2&amp;question=10"> I can't log into my account. Can you help? </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4 accordion">
            <div class="accordion-item" id="help-category-3" data-toggle-group="help-category-group-3">
              <div class="toggler help-support--content--col-heading" data-toggle-target="#help-category-3"
                data-toggle-group="help-category-group-3"
                data-toggle-on-active-match-height="#help-category-3 .accordion-item--content-wrapper"
                data-toggle-on-active-match-height-src="#help-category-3 .help-support--content--col-content"
                data-toggle-on-active-scroll-to-view-container="#help-category-3"
                data-toggle-on-active-scroll-to-view-view="#help-category-3"
                data-toggle-on-active-scroll-to-view-offset="15" data-toggle-on-active-scroll-to-view-delay="300"
                data-toggle-on-active-scroll-to-view-duration="250">
                <img src="@/assets/images/help-support/icon-trading.svg">
                <h4> {{$t('faq.trading')}} </h4>
              </div>
              <div class="accordion-item--content-wrapper">
                <div class="help-support--content--col-content">
                  <router-link to="/resources/faq?category=5&amp;question=4"> What are the assets that I can trade? </router-link>
                  <router-link to="/resources/faq?category=5&amp;question=37"> What are HighLow Points? </router-link>
                  <router-link to="/resources/faq?category=5&amp;question=34"> What is a stale rate? </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="help-support--content--section-footer">
            <router-link to="/resources/faq"> View all FAQs </router-link>
          </div>
        </div>
        <div class="row">
          <div class="help-support--content--section-heading">
            <h3> Can't find what you need? </h3>
          </div>
        </div>
      </div>
    </div>

    <div class="help-support--content">
      <div class="container">
        <div class="row">
          <div class="help-support--tab-button-container">
            <div id="help-support-tab1" class="toggler help-support--tab-button active" data-toggle-class="active"
              data-toggle-target="#help-support-1" data-toggle-group="help-support--tabs"
              data-toggle-self-off-disabled="true">
              <span> Submit a help request </span><span class="small-dot inactive"></span>
              <span class="recommended-button"><span class="small-dot"></span> Recommended </span>
            </div>
            <div id="help-support-tab2" class="toggler help-support--tab-button" data-toggle-class="active"
              data-toggle-target="#help-support-2" data-toggle-group="help-support--tabs"
              data-toggle-self-off-disabled="true">
              <span class="tab-button-text"> Speak with a consultant </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="help-support--content bg-light-grey">
      <div class="container">
        <div class="row">
          <div class="help-support--tab-content-container">
            <div id="help-support-1" class="help-support--tab-content active" data-toggle-group="help-support--tabs">

              <form class="ajax support-form" novalidate="novalidate" autocomplete="off" id="support-form">

                <div id="help-support-form-instance" class="support-enquiry-select-wrapper">
                  <div>
                    <h4> Tell us about your enquiry and we’ll get back to you promptly. </h4>
                    <div class="support-form--step step1 active">
                      <div class="support-form--header"><span><b>1.</b> Enquiry details </span> <span
                          class="support-form--step-tick"><img
                            src="@/assets/images/help-support/icon-tick-round-green.svg"></span>
                        <span class="support-form--step-edit"> Edit </span></div>
                      <div class="support-form--body">
                        <div class="support-form--field-wrapper active"><label for="nature"
                            class="support-form--field-label">
                            What's the nature of your enquiry?
                          </label>
                          <div class="support-form--field"><select name="nature" style="display: none;">
                              <option value="" disabled="disabled">Select nature of enquiry</option>
                              <option value="Problem or Question">I have a question/problem that needs resolved</option>
                              <option value="Feature Request">I would like to request a feature</option>
                            </select><span id="" class="selectboxit-container selectboxit-container" role="combobox"
                              aria-autocomplete="list" aria-haspopup="true" aria-expanded="false" aria-owns=""><span
                                id="" class="selectboxit  selectboxit-enabled selectboxit-btn" name="nature"
                                tabindex="0" unselectable="on"><span class="selectboxit-option-icon-container"><i id=""
                                    class="selectboxit-option-icon  selectboxit-container selectboxit-default-icon"
                                    unselectable="on"></i></span><span id="" class="selectboxit-text" unselectable="on"
                                  data-val="" style="max-width: 147px;" aria-live="polite">Select nature of
                                  enquiry</span><span id="" class="selectboxit-arrow-container" unselectable="on"><i
                                    id="" class="selectboxit-arrow selectboxit-default-arrow"
                                    unselectable="on"></i></span></span>
                              <ul
                                class="selectboxit-options selectboxit-list os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-scrollbar-vertical-hidden os-host-transition"
                                tabindex="-1" role="listbox" aria-hidden="true">
                                <div class="os-resize-observer-host">
                                  <div class="os-resize-observer observed" style="left: 0px; right: auto;"></div>
                                </div>
                                <div class="os-size-auto-observer" style="height: calc(100% + 1px); float: left;">
                                  <div class="os-resize-observer observed"></div>
                                </div>
                                <div class="os-content-glue" style="margin: 0px; width: 0px; height: 0px;"></div>
                                <div class="os-padding">
                                  <div class="os-viewport" style="">
                                    <div class="os-content" style="padding: 0px; height: 100%; width: 100%;">
                                      <li data-id="0" data-val="" data-disabled="false"
                                        class="selectboxit-option  selectboxit-option-first selectboxit-selected"
                                        role="option"><a class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Select
                                          nature of enquiry</a></li>
                                      <li data-id="1" data-val="Problem or Question" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>I have a
                                          question/problem that needs resolved</a></li>
                                      <li data-id="2" data-val="Feature Request" data-disabled="false"
                                        class="selectboxit-option  selectboxit-option-last" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>I would
                                          like to request a feature</a></li>
                                    </div>
                                  </div>
                                </div>
                                <div class="os-scrollbar os-scrollbar-horizontal os-scrollbar-unusable">
                                  <div class="os-scrollbar-track os-scrollbar-track-off">
                                    <div class="os-scrollbar-handle" style="transform: translate(0px);"></div>
                                  </div>
                                </div>
                                <div class="os-scrollbar os-scrollbar-vertical os-scrollbar-unusable">
                                  <div class="os-scrollbar-track os-scrollbar-track-off">
                                    <div class="os-scrollbar-handle" style="transform: translate(0px);"></div>
                                  </div>
                                </div>
                                <div class="os-scrollbar-corner"></div>
                              </ul>
                            </span></div>
                        </div>
                        <div class="support-form--field-wrapper"><label for="area" class="support-form--field-label">
                            About which area is your question/problem?
                          </label>
                          <div class="support-form--field"><select name="area" style="display: none;">
                              <option value="" disabled="disabled">Select area</option>
                              <option value="My Account"
                                options="[object Object],[object Object],[object Object],[object Object],[object Object]">
                                My Account</option>
                              <option value="Banking"
                                options="[object Object],[object Object],[object Object],[object Object],[object Object],[object Object],[object Object]">
                                Banking</option>
                              <option value="Trading"
                                options="[object Object],[object Object],[object Object],[object Object],[object Object]">
                                Trading</option>
                              <option value="Tech and Software"
                                options="[object Object],[object Object],[object Object],[object Object]">Tech and
                                Software</option>
                              <option value="Cashback and Loyalty"
                                options="[object Object],[object Object],[object Object],[object Object]">Cashback and
                                Loyalty</option>
                              <option value="Affiliates" options="[object Object],[object Object]">Affiliate Marketing
                              </option>
                              <option value="Others">Others</option>
                            </select><span id="" class="selectboxit-container selectboxit-container" role="combobox"
                              aria-autocomplete="list" aria-haspopup="true" aria-expanded="false" aria-owns=""><span
                                id="" class="selectboxit  selectboxit-enabled selectboxit-btn" name="area" tabindex="0"
                                unselectable="on"><span class="selectboxit-option-icon-container"><i id=""
                                    class="selectboxit-option-icon  selectboxit-container selectboxit-default-icon"
                                    unselectable="on"></i></span><span id="" class="selectboxit-text" unselectable="on"
                                  data-val="" style="max-width: 69px;" aria-live="polite">Select area</span><span id=""
                                  class="selectboxit-arrow-container" unselectable="on"><i id=""
                                    class="selectboxit-arrow selectboxit-default-arrow"
                                    unselectable="on"></i></span></span>
                              <ul
                                class="selectboxit-options selectboxit-list os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-scrollbar-vertical-hidden os-host-transition"
                                tabindex="-1" role="listbox" aria-hidden="true">
                                <div class="os-resize-observer-host">
                                  <div class="os-resize-observer observed" style="left: 0px; right: auto;"></div>
                                </div>
                                <div class="os-size-auto-observer" style="height: calc(100% + 1px); float: left;">
                                  <div class="os-resize-observer observed"></div>
                                </div>
                                <div class="os-content-glue" style="margin: 0px; width: 0px; height: 0px;"></div>
                                <div class="os-padding">
                                  <div class="os-viewport" style="">
                                    <div class="os-content" style="padding: 0px; height: 100%; width: 100%;">
                                      <li data-id="0" data-val="" data-disabled="false"
                                        class="selectboxit-option  selectboxit-option-first selectboxit-selected"
                                        role="option"><a class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Select
                                          area</a></li>
                                      <li data-id="1" data-val="My Account" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>My
                                          Account</a></li>
                                      <li data-id="2" data-val="Banking" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Banking</a>
                                      </li>
                                      <li data-id="3" data-val="Trading" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Trading</a>
                                      </li>
                                      <li data-id="4" data-val="Tech and Software" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Tech and
                                          Software</a></li>
                                      <li data-id="5" data-val="Cashback and Loyalty" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Cashback
                                          and Loyalty</a></li>
                                      <li data-id="6" data-val="Affiliates" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Affiliate
                                          Marketing</a></li>
                                      <li data-id="7" data-val="Others" data-disabled="false"
                                        class="selectboxit-option  selectboxit-option-last" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Others</a>
                                      </li>
                                    </div>
                                  </div>
                                </div>
                                <div class="os-scrollbar os-scrollbar-horizontal os-scrollbar-unusable">
                                  <div class="os-scrollbar-track os-scrollbar-track-off">
                                    <div class="os-scrollbar-handle" style="transform: translate(0px);"></div>
                                  </div>
                                </div>
                                <div class="os-scrollbar os-scrollbar-vertical os-scrollbar-unusable">
                                  <div class="os-scrollbar-track os-scrollbar-track-off">
                                    <div class="os-scrollbar-handle" style="transform: translate(0px);"></div>
                                  </div>
                                </div>
                                <div class="os-scrollbar-corner"></div>
                              </ul>
                            </span></div>
                        </div>
                        <div class="support-form--field-wrapper"><label for="issue" class="support-form--field-label">
                            What specifically is your My Account issue?
                          </label>
                          <div class="support-form--field"><select name="issue" style="display: none;">
                              <option value="" disabled="disabled">Select issue</option>
                              <option value="Accessing account">I'm having trouble accessing my account</option>
                              <option value="Opening account">I have an account opening enquiry</option>
                              <option value="Changing details">I would like to make a change to my details</option>
                              <option value="Closing account">I would like to close my account</option>
                              <option value="Other">Other</option>
                            </select><span id="" class="selectboxit-container selectboxit-container" role="combobox"
                              aria-autocomplete="list" aria-haspopup="true" aria-expanded="false" aria-owns=""><span
                                id="" class="selectboxit  selectboxit-enabled selectboxit-btn" name="issue" tabindex="0"
                                unselectable="on"><span class="selectboxit-option-icon-container"><i id=""
                                    class="selectboxit-option-icon  selectboxit-container selectboxit-default-icon"
                                    unselectable="on"></i></span><span id="" class="selectboxit-text" unselectable="on"
                                  data-val="" style="max-width: 75px;" aria-live="polite">Select issue</span><span id=""
                                  class="selectboxit-arrow-container" unselectable="on"><i id=""
                                    class="selectboxit-arrow selectboxit-default-arrow"
                                    unselectable="on"></i></span></span>
                              <ul
                                class="selectboxit-options selectboxit-list os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-scrollbar-vertical-hidden os-host-transition"
                                tabindex="-1" role="listbox" aria-hidden="true">
                                <div class="os-resize-observer-host">
                                  <div class="os-resize-observer observed" style="left: 0px; right: auto;"></div>
                                </div>
                                <div class="os-size-auto-observer" style="height: calc(100% + 1px); float: left;">
                                  <div class="os-resize-observer observed"></div>
                                </div>
                                <div class="os-content-glue" style="margin: 0px; width: 0px; height: 0px;"></div>
                                <div class="os-padding">
                                  <div class="os-viewport" style="">
                                    <div class="os-content" style="padding: 0px; height: 100%; width: 100%;">
                                      <li data-id="0" data-val="" data-disabled="false"
                                        class="selectboxit-option  selectboxit-option-first selectboxit-selected"
                                        role="option"><a class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Select
                                          issue</a></li>
                                      <li data-id="1" data-val="Accessing account" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>I'm
                                          having trouble accessing my account</a></li>
                                      <li data-id="2" data-val="Opening account" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>I have
                                          an account opening enquiry</a></li>
                                      <li data-id="3" data-val="Changing details" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>I would
                                          like to make a change to my details</a></li>
                                      <li data-id="4" data-val="Closing account" data-disabled="false"
                                        class="selectboxit-option" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>I would
                                          like to close my account</a></li>
                                      <li data-id="5" data-val="Other" data-disabled="false"
                                        class="selectboxit-option  selectboxit-option-last" role="option"><a
                                          class="selectboxit-option-anchor"><span
                                            class="selectboxit-option-icon-container"><i
                                              class="selectboxit-option-icon  selectboxit-container"></i></span>Other</a>
                                      </li>
                                    </div>
                                  </div>
                                </div>
                                <div class="os-scrollbar os-scrollbar-horizontal os-scrollbar-unusable">
                                  <div class="os-scrollbar-track os-scrollbar-track-off">
                                    <div class="os-scrollbar-handle" style="transform: translate(0px);"></div>
                                  </div>
                                </div>
                                <div class="os-scrollbar os-scrollbar-vertical os-scrollbar-unusable">
                                  <div class="os-scrollbar-track os-scrollbar-track-off">
                                    <div class="os-scrollbar-handle" style="transform: translate(0px);"></div>
                                  </div>
                                </div>
                                <div class="os-scrollbar-corner"></div>
                              </ul>
                            </span></div>
                        </div>
                        <div class="support-form--field-wrapper"><label for="issue" class="support-form--field-label">
                            Please provide any details that might help &nbsp;<span class="optional"> (Optional)
                            </span></label>
                          <div class="support-form--field"><textarea name="details"></textarea></div>
                        </div>
                        <div class="support-form--field-wrapper attachments"><label for="issue"
                            class="support-form--field-label attachments"><span class="label-arrow"></span> Attachments
                            &nbsp;<span class="optional"> (Optional) </span></label>
                          <div class="support-form--field support-form--uploader-wrapper">
                            <p class="attach-desc-text"> Resolve your enquiry more quickly by attaching any files or
                              screenshots that might help us… </p>
                            <div class="support-form--uploader file-uploader-upload-area" id="support-form--uploads"
                              fallback-file-select-tittle="Select file">
                              <div style="display: none;">
                                <div class="qq-uploader-selector qq-uploader">
                                  <div class="qq-upload-drop-area-selector qq-upload-drop-area"><span
                                      class="uploader-drop-area--empty"><span class="icon"></span> <span
                                        class="upload-drop-area-item--uploading">
                                        <div class="qq-progress-bar-container-selector">
                                          <div role="progressbar" aria-valuenow="0" aria-valuemin="0"
                                            aria-valuemax="100" class="qq-progress-bar-selector qq-progress-bar"></div>
                                        </div> <span class="qq-upload-file-selector qq-upload-file"></span> <span
                                          class="qq-upload-cancel-selector qq-upload-cancel"></span>
                                      </span> <span class="qq-upload-drop-area-text"><span><span
                                            class="upload-drop-area-text--instruction">
                                            Drag and drop to upload
                                          </span> <span class="upload-drop-area-text--uploading">
                                            Uploading
                                          </span></span></span></span>
                                    <div class="qq-upload-button-selector qq-upload-button">
                                      <div class="qq-upload-button-text"><span> Select file</span></div>
                                    </div>
                                  </div>
                                  <div class="qq-file-restrictions"><span> Total files uploaded must not exceed </span>
                                    15MB. <span> File types supported:</span> jpeg, jpg, png, pdf</div>
                                  <ul role="region" aria-live="polite" aria-relevant="additions removals"
                                    class="qq-upload-list-selector qq-upload-list">
                                    <li><span class="uploader-drop-area--item-details"><span role="status"
                                          class="qq-upload-status-text-selector qq-upload-status-text"></span>
                                        <div class="qq-file-info"><span
                                            class="qq-upload-file-selector qq-upload-file"></span><span
                                            class="qq-upload-delete-selector qq-upload-delete-text"></span></div>
                                        <div class="upload-error-ui upload-error-text"><span> We could not process your
                                            request. <span class="qq-upload-cancel-selector qq-upload-cancel"> Cancel
                                              and try again. </span></span></div>
                                      </span></li>
                                  </ul>
                                </div>
                              </div>
                              <div>
                                <div class="qq-uploader-selector qq-uploader">
                                  <div class="qq-upload-drop-area-selector qq-upload-drop-area"><span
                                      class="uploader-drop-area--empty"><span class="icon"></span> <span
                                        class="upload-drop-area-item--uploading">
                                        <div class="qq-progress-bar-container-selector">
                                          <div role="progressbar" aria-valuenow="0" aria-valuemin="0"
                                            aria-valuemax="100" class="qq-progress-bar-selector qq-progress-bar"></div>
                                        </div> <span class="qq-upload-file-selector qq-upload-file"></span> <span
                                          class="qq-upload-cancel-selector qq-upload-cancel"></span>
                                      </span> <span class="qq-upload-drop-area-text"><span><span
                                            class="upload-drop-area-text--instruction">
                                            Drag and drop to upload
                                          </span> <span class="upload-drop-area-text--uploading">
                                            Uploading
                                          </span></span></span></span>
                                    <div class="qq-upload-button-selector qq-upload-button"
                                      style="position: relative; overflow: hidden; direction: ltr;">
                                      <div class="qq-upload-button-text"><span> Select file</span></div><input
                                        qq-button-id="e449764b-3f91-48d9-b301-779be6e284b4" title="file input"
                                        multiple="" type="file" name="file"
                                        style="position: absolute; right: 0px; top: 0px; font-family: Arial; font-size: 118px; margin: 0px; padding: 0px; cursor: pointer; opacity: 0; height: 100%;">
                                    </div>
                                  </div>
                                  <div class="qq-file-restrictions"><span> Total files uploaded must not exceed </span>
                                    15MB. <span> File types supported:</span> jpeg, jpg, png, pdf</div>
                                  <ul role="region" aria-live="polite" aria-relevant="additions removals"
                                    class="qq-upload-list-selector qq-upload-list"></ul>
                                </div>
                              </div> <input type="hidden" name="uploads">
                            </div>
                          </div>
                        </div>
                        <div class="support-form--submit">
                          <div class="support-form--submit-btn">
                            CONTINUE
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="support-form--step step2">
                      <div class="support-form--header"><span><b>2.</b>Your information</span> <span
                          class="support-form--step-tick"><img
                            src="@/assets/images/help-support/icon-tick-round-green.svg"></span>
                      </div>
                      <div class="support-form--body">
                        <div class="support-form--field-wrapper active"><label for="userid"
                            class="support-form--field-label">
                            User ID &nbsp;<span class="optional">(Optional)</span>
                            <div class="sub-label-wrapper"><router-link to="/forgot-username" target="_blank"
                                class="label-link"> Forgotten your User ID?</router-link> <span class="sub-label">This will help
                                us to resolve your issue efficiently. </span></div>
                          </label>
                          <div class="support-form--field"><input id="username" name="userid" type="text"
                              placeholder="e.g.HL1234" data-msg-remote="Please enter a valid Username"></div>
                        </div>
                        <div class="support-form--field-wrapper active"><label for="name"
                            class="support-form--field-label">
                            Your name
                          </label>
                          <div class="support-form--field"><input name="name" type="text"
                              data-validation-engine="validate[required]" required="required"
                              data-msg-required="This field is required."></div>
                        </div>
                        <div class="support-form--field-wrapper active"><label for="email"
                            class="support-form--field-label">
                            Email address
                          </label>
                          <div class="support-form--field"><input id="emailAddress" name="email" type="email"
                              placeholder="This is the email we'll use to contact you."
                              data-rule-pattern="^(([^<>()[\]\\.,;:\s@\&quot;]+(\.[^<>()[\]\\.,;:\s@\&quot;]+)*)|(\&quot;.+\&quot;))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$"
                              data-msg-pattern="Please enter a valid email address"
                              data-validation-engine="validate[required,custom[email]]" required="required"
                              data-msg-required="This field is required." data-rule-email="true"
                              data-msg-email=" Please enter a valid email address "></div>
                        </div>
                        <div class="support-form--submit"><button
                            class="support-form--submit-btn form-ajax--submit form-loading-indicator"><span
                              class="loading-indicator">
                              <div class="loader"></div>
                            </span> <span class="form-ajax--loading-indicator--text default">
                              SUBMIT HELP REQUEST
                            </span></button></div>
                      </div>
                    </div>
                    <div class="support-form--submitted"><img
                        src="@/assets/images/help-support/icon-tick-circle-orange.svg">
                      <h3> Your request has been submitted </h3>
                      <p> One of our customer support staff will reach out to you promptly. <br class="em_hide">
                        Please check your email inbox for a message from HighLow Support.</p> <span>If you don't see
                        one, try checking your email's spam and trash folders.</span>
                    </div>
                  </div>
                </div>
              </form>

            </div>
            <div id="help-support-2" class="help-support--tab-content" data-toggle-group="help-support--tabs">
              <div id="help-support-number-instance">
                <h4> Our friendly customer service staff are here to help. </h4>
                <div class="support-number--container">
                  <div class="default">
                    <div class="support-number--box hide">
                      Average wait time: 15 minutes. <br>
                      <p class="support-number--text"> We are experiencing higher than normal call volumes at the
                        moment.</p>
                    </div>
                    <h3> Your time is valuable </h3>
                    <p class="support-number--default--para"> By submitting a help request we can manage your enquiry
                      with optimal efficiency and accuracy. </p>
                    <button id="help-support-2--submit-request" class="support-form--submit-btn">SUBMIT HELP REQUEST
                    </button>
                    <div id="help-support-2--show-support-number" class="support-number--link"> I'd prefer to speak with
                      someone</div>

                  </div>

                  <div class="support-number">
                    <h2><img src="@/assets/images/help-support/icon-phone.svg"
                        class="ic-phone"> 1300-870-442</h2>
                    <p>Available weekdays between 08:00 to 18:00 (AEDT/AEST). Call charges may apply.</p>
                    <p class="support-number--text small">HighLow account holders: please make sure you have your <span
                        class="tooltip-button">User ID<span class="tooltip-content support-tooltip-content"><span id=""
                            class="ic-tooltip-close-btn toggler" data-toggle="tooltip"
                            data-toggle-disable-propagation="true" data-original-title="" title=""><span
                              class="ic-tooltip-close"></span></span>E.g. HL12345 – often located at the top of emails
                          you receive from HighLow Markets.<br><router-link to="/forgot-username" target="_blank">Retrieve Your
                            ID</router-link></span></span> on hand.</p>

                    <div class="support-number--box">
                      Average wait time: <span class="word">15 minutes.</span> Submit a <a
                        id="help-support-2--submit-request-link" class="support-number--link">Help Request</a> instead
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </fragment>
</template>

<script>
  import "../../assets/css/help-support.css";
  export default {}
</script>